import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  width: 100%;
  animation: ${fadeIn} 0.5s ease-out;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  overflow-x: auto;
  box-sizing: border-box;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;

  thead {
    tr {
      border-bottom: 2px solid #f3f4f6;
      th {
        text-align: left;
        padding: 15px;
        color: #6b7280;
        font-weight: 600;
        font-size: 14px;
        text-transform: uppercase;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #f9fafb;
      transition: background 0.2s;
      cursor: pointer; /* ADICIONADO AQUI */

      &:hover {
        background: #ffffef;
      }

      td {
        padding: 15px;
        color: #111827;
        font-size: 14px;
        font-weight: 500;

        &.amount {
          font-weight: 700;
          color: #111827;
        }

        &.date {
          color: #6b7280;
        }
      }
    }
  }
`;

export const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;

  ${(props) => {
    switch (props.status) {
      case "PENDING":
        return `
          background: #fff7ed;
          color: #c2410c;
          border: 1px solid #ffedd5;
        `;
      case "PAID":
        return `
          background: #ecfdf5;
          color: #047857;
          border: 1px solid #d1fae5;
        `;
      case "CANCELED":
        return `
          background: #f3f4f6;
          color: #4b5563;
          border: 1px solid #e5e7eb;
        `;
      case "REJECTED":
        return `
          background: #fef2f2;
          color: #b91c1c;
          border: 1px solid #fee2e2;
        `;
      default:
        return `
          background: #f3f4f6;
          color: #374151;
        `;
    }
  }}
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  gap: 10px;

  span {
    font-size: 14px;
    color: #6b7280;
  }
`;

export const PageButton = styled.button`
  background: white;
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  color: #374151;
  font-weight: 600;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: #d4af37;
    color: #d4af37;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f9fafb;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #9ca3af;
  font-size: 16px;
`;
